import React from "react";
import { Box, Typography } from "@mui/material";

import withStyles from '@mui/styles/withStyles';

const styles = (theme) => ({
  blueBox: {
    color: "#000",
    minHeight: 180,
    borderRadius: "0 0 0 60px",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    paddingBottom: 10,
  },
  content: {
    paddingTop: 30,
    paddingLeft: 56,
  },
  title: {
    fontWeight: 300,
  },
  children: {
    display: "flex",
    flexDirection: "column",
    alignItems: "bottom",
    height: "100%",
    margin: "auto",
    marginTop: "15px",
    marginBottom: "10px",
  },
});

const BlueBox = ({ classes, text, children, className }) => {
  return (
    <div className={className}>
      <Box className={classes.blueBox} width="100%">
        <div className={classes.content}>
          <Typography variant="h1" color="inherit" className={classes.title}>
            {text}
          </Typography>
        </div>
        <div className={classes.children}>{children}</div>
      </Box>
    </div>
  );
};

export default withStyles(styles)(BlueBox);
